import Vue from 'vue';  //引入vue  
import Vuex from 'vuex'; //引入vuex
Vue.use(Vuex)
const state = {       //相当于data
    isActive:localStorage.getItem('ishot')
}
export default new Vuex.Store({
    state
})


// WEBPACK FOOTER //
// ./src/store/index.js